import { Injectable } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { SmtpForm } from '@models/models';
import { ValidationProvider } from '@services/helpers/validation.service';

@Injectable()
export class EmailSettingsService {
	constructor(
		private messageService: MessageService,
		private validationService: ValidationProvider
	) {}

	validateDomain(domain: string): boolean {
		if (domain.length <= 4) {
			this.messageService.showToaster('e_6', 'emailSettings');
			return false;
		}

		if (domain.indexOf(' ') > 0) {
			this.messageService.showToaster('e_7', 'emailSettings');
			return false;
		}

		if (domain.length >= 65) {
			this.messageService.showToaster('e_9', 'emailSettings');
			return false;
		}

		const regex = /[@#а-яА-Я№!$%^&*()+|~=`{}\[\]:";'<>?,\/]/;
		const result = domain.match(regex);

		if (result !== null) {
			this.messageService.showToaster('e_8', 'emailSettings');
			return false;
		}

		return true;
	}

	isSMTPSettingsValid(data: SmtpForm): boolean {
		const { from, serverUsername, password, host, port } = data;

		if (this.validationService.isStringEmptySMTP(from)) {
			this.messageService.showToaster('e_3', 'emailSettings', 'name');
			return false;
		}

		if (this.validationService.isStringEmptySMTP(serverUsername)) {
			this.messageService.showToaster('e_3', 'emailSettings', 'username');
			return false;
		}

		if (this.validationService.isStringEmptySMTP(password)) {
			this.messageService.showToaster('e_3', 'emailSettings', 'password');
			return false;
		}

		if (this.validationService.isStringEmptySMTP(host)) {
			this.messageService.showToaster(
				'e_3',
				'emailSettings',
				'SMTP server details'
			);
			return false;
		}

		if (this.validationService.isStringEmptySMTP(port)) {
			this.messageService.showToaster(
				'e_3',
				'emailSettings',
				'SMTP port number'
			);
			return false;
		}
		return true;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/settings/email-settings.service.ts